module.exports = __webpack_public_path__ + "img/logo.5a103a84.png";